import {
  WpFullCampaign,
  WpCampaignStructure,
  WpStructureType,
} from '../contexts/campaign';

/**
 * Ordered list of step ids for a timeline bucket. For v2 campaigns, uses
 * features[].orderIndex; otherwise uses structure.{feature|before|appointment}.
 */
export function getTimelineStructure(
  campaign: WpFullCampaign | null | undefined,
  structureType: WpStructureType
): WpCampaignStructure[] {
  if (!campaign) return [];
  const key =
    structureType === WpStructureType.FEATURE
      ? 'feature'
      : structureType === WpStructureType.BEFORE
        ? 'before'
        : 'appointment';
  const bucket = campaign.structure?.[key] ?? [];
  if (!campaign.v2) return bucket;

  const sorted = [...(campaign.features ?? [])].sort(
    (a, b) => (a.orderIndex ?? 0) - (b.orderIndex ?? 0)
  );
  const filtered = sorted.filter((f) => f.structureType === structureType);
  return filtered.map((f) => {
    const existing = bucket.find((s) => s.id === f.id);
    if (existing) return existing;
    return {
      id: f.id,
      featureType: f.featureType,
      label: f.label,
      pitchId: f.pitch?.id ?? '',
      structure: f.pitch?.structure ?? [],
    } as WpCampaignStructure;
  });
}

export function getOrderedStepIds(
  campaign: WpFullCampaign | null | undefined,
  structureType: WpStructureType
): string[] {
  return getTimelineStructure(campaign, structureType).map((s) => s.id);
}
